import { Trans, useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Stack, Typography, TypographyVariants } from '@lyearn/ui';
import { roundedTillTwoDecimal } from '@/modules/user-survey/views/UserSurveyAnalytics/views/SurveyDetails/utils/roundedTillTwoDecimal';
import { QuizResultEnum } from '@/types/schema';

type ScoreProps = {
  status: QuizResultEnum;
  score: number;
  overrides?: {
    title?: TypographyVariants;
    description?: TypographyVariants;
    descriptionLabel?: TypographyVariants;
  };
};
const Score: React.FC<ScoreProps> = ({ status, score, overrides }) => {
  const { t } = useTranslation();

  const isResultPass = status === QuizResultEnum.Pass;

  // Weighted/partial-credit scoring can produce floating point noise (e.g.
  // 1.7999999523162842) — round to 2 decimal places for display.
  const roundedScore = roundedTillTwoDecimal(score);

  return (
    <Stack
      className={cn(
        'px-16 py-12 border rounded-12 mt-24',
        isResultPass
          ? 'bg-bg-success-light border-border-success-dark'
          : 'bg-bg-error-light border-border-error-dark',
      )}
      direction="col"
      gapY={4}>
      <Typography variant={overrides?.title ?? 'heading-xxs'}>
        {isResultPass ? t('Common:ContentStatus.Pass') : t('Common:ContentStatus.Fail')}
      </Typography>
      <Typography color="text-text-paragraph" variant={overrides?.description ?? 'body-short-02'}>
        <Trans
          i18nKey="QuizPlayer:YourScoreIs"
          values={{ score: roundedScore }}
          variant={overrides?.descriptionLabel}
        />
      </Typography>
    </Stack>
  );
};

export default Score;
